
<template>
  <div class="US-view">
    <h1>US</h1>
  </div>
</template>

<script>
export default {
  name: "TheUSView",
};
</script>
